import algoliasearch from 'algoliasearch/lite';

const searchClient = algoliasearch(
  '3GW4ZJXLIM',
  '7ff6027389cba071b989d78745e5ef66',
);
export {searchClient};
